import React, { ReactNode } from "react";
import { Card, Row, Col } from "react-bootstrap";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import MenuItemCard from "../../organisms/MenuItemCard";
import { useUsuarioActual } from "../../../services/authServicios";
import { puedeAccederRuta } from "../../../services/rolAutorizacion";
import { RUTA_TRANSPORTE_HOY, RUTA_TRANSPORTE_PLANEACION } from "../../../services/rutas";

function CardSection() {
  const { data: usuario } = useUsuarioActual();

  return (
    <Row className="justify-content-center">
      <div className="col-xs-12 col-md-12 col-lg-11 col-xxl-8">
        <Card>
          <Card.Body>
            <Row className="justify-content-center mb-3">
              {puedeAccederRuta(usuario, RUTA_TRANSPORTE_HOY) && (
                <CardCol>
                  <MenuItemCard
                    Icono={FactCheckIcon}
                    ruta={RUTA_TRANSPORTE_HOY}
                    titulo="Hoja diaria"
                    descripcion="Confirma recogida y entrega de mascotas agendadas para hoy."
                  />
                </CardCol>
              )}
              {puedeAccederRuta(usuario, RUTA_TRANSPORTE_PLANEACION) && (
                <CardCol>
                  <MenuItemCard
                    Icono={CalendarMonthIcon}
                    ruta={RUTA_TRANSPORTE_PLANEACION}
                    titulo="Planeación"
                    descripcion="Visualiza y edita transporte de mascotas agendadas."
                  />
                </CardCol>
              )}
            </Row>
          </Card.Body>
        </Card>
      </div>
    </Row>
  );
}

const CardCol = ({ children }: { children: ReactNode }) => {
  return (
    <Col xs={12} md={4} sm={6}>
      {children}
    </Col>
  );
};
export default CardSection;
